import axiosInstance from '../variables/api/axiosInstance';
import { avecLibelleTraduit } from '../i18n/libelles';

const BASE = '/v1/cles-api';

const unwrapList = (res) => {
  const d = res?.data?.data;
  if (Array.isArray(d)) return d;
  if (d?.content && Array.isArray(d.content)) return d.content;
  return [];
};

const unwrap = (res) => res?.data?.data;

export async function creerCleApi(payload) {
  return unwrap(await axiosInstance.post(`${BASE}`, payload));
}

export async function getCleApi(trackingId) {
  return unwrap(await axiosInstance.get(`${BASE}/${trackingId}`));
}

export async function listerClesParCompagnie(compagnieId) {
  return unwrapList(await axiosInstance.get(`${BASE}/compagnie/${compagnieId}`));
}

export async function revoquerCle(trackingId) {
  return unwrap(await axiosInstance.put(`${BASE}/${trackingId}/revoquer`));
}

export async function suspendreCle(trackingId) {
  return unwrap(await axiosInstance.put(`${BASE}/${trackingId}/suspendre`));
}

export async function reactiverCle(trackingId) {
  return unwrap(await axiosInstance.put(`${BASE}/${trackingId}/reactiver`));
}

export async function regenererSecret(trackingId) {
  return unwrap(await axiosInstance.post(`${BASE}/${trackingId}/regenerer-secret`));
}

export async function consulterQuota(trackingId) {
  return unwrap(await axiosInstance.get(`${BASE}/${trackingId}/quota`));
}

export const STATUTS_CLE_API = avecLibelleTraduit({
  ACTIVE:    { color: 'success' },
  SUSPENDUE: { color: 'warning' },
  REVOQUEE:  { color: 'error' },
  EXPIREE:   { color: 'default' },
}, 'referentiels:statutsCleApi');

export const ENVIRONNEMENTS = avecLibelleTraduit({
  PRODUCTION: { color: 'green' },
  SANDBOX:    { color: 'orange' },
}, 'referentiels:environnementsCleApi');
